import _ from 'lodash';
import config from '../../config/config';
import { doAction } from '../middleware/fetchMiddleware';
import { postMessage } from '../utils/iframeUtils';

export const actionTypes = {
    GET_SELF: 'getSelf'
};

const initialState = {
    isSelfLoaded: false,
    isEnabledForVTerm: undefined
};

/**
 * Fetches the logged-in user's record (including the account-level
 * `isEnabledForVTerm` flag set via the "Enable Virtual Terminal" checkbox in
 * Nexio Super) so the app can block access when Virtual Terminal is not
 * enabled for the account.
 */
const getSelf = () => (dispatch) => {
    dispatch({
        type: doAction.fetch(actionTypes.GET_SELF),
        fetchParams: {
            url: `${config.userManagementApiUrl}/account/whoAmI`,
            method: 'get'
        },
        onFail: (action, error) => {
            postMessage('error', {
                ...action,
                message: error
            });
        }
    });
};

export const actions = {
    getSelf
};

export function reducers(state = initialState, action) {
    switch (action.type) {
        case doAction.fetch(actionTypes.GET_SELF):
            // Leave isSelfLoaded as it is. The first lookup starts false, so the
            // form stays hidden until it resolves. Resetting it on a refresh
            // (tab focus calls refresh → getSelf) unmounts Terminal and drops
            // what the cashier typed.
            return state;
        case doAction.success(actionTypes.GET_SELF):
            return {
                ...state,
                isSelfLoaded: true,
                isEnabledForVTerm: _.get(action, 'payload.isEnabledForVTerm') === true
            };
        case doAction.error(actionTypes.GET_SELF):
            // Fail closed on the first lookup. A later lookup that fails keeps
            // the entitlement already on screen, so a tab-focus refresh cannot
            // replace a working form with the disabled notice.
            if (state.isSelfLoaded) {
                return state;
            }

            return {
                ...state,
                isSelfLoaded: true,
                isEnabledForVTerm: false
            };
        default:
            return state;
    }
}
